import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import React from 'react';

export interface IFormProps extends FormItemProps {}

const FormItem: React.FC<IFormProps> = ({ children, ...props }) => {
  return <Form.Item {...props}>{children}</Form.Item>;
};

export default FormItem;
